import EmptyLink from 'components/EmptyLink'
import BlueButton from 'components/inputs/BlueButton'
import NumberInput from 'components/inputs/NumberInput'
import { TOneItemCallback } from 'HttpRequests'
import React, { useCallback, useState } from 'react'

interface IEnterCodeFormProps {
  onGoToRegistration: VoidFunction
  onEnterCode: (code: number) => void
  onSetMessage: TOneItemCallback<string>
}

const EnterCodeForm: React.FC<IEnterCodeFormProps> = ({
  onGoToRegistration,
  onEnterCode,
  onSetMessage,
}) => {
  const [code, setCode] = useState<number | undefined>(undefined)

  const handleChangeCode = (value: number | '') => {
    if (value === '') {
      setCode(undefined)
    } else {
      setCode(value)
    }
  }

  const handleEnterCode = useCallback(() => {
    if (code) {
      onEnterCode(code)
    } else {
      onSetMessage('Введите код подтверждения регистрации.')
    }
  }, [code, onEnterCode, onSetMessage])

  const cancelCode = useCallback(() => {
    onGoToRegistration()
    onSetMessage('')
  }, [onGoToRegistration, onSetMessage])

  return (
    <>
      <p>Введите код подтверждения</p>
      <NumberInput
        defaultValue={code}
        onChange={handleChangeCode}
        onEntered={handleEnterCode}
      />

      <div className='m-2' />
      <BlueButton onClick={handleEnterCode} style={{ width: '100%' }}>
        Подтвердить
      </BlueButton>

      <div className='m-2' />
      <EmptyLink onClick={cancelCode}>Отмена</EmptyLink>
    </>
  )
}
export default EnterCodeForm
